import { render } from "./ServiceView.vue?vue&type=template&id=30d0360e&scoped=true"
const script = {}

import "./ServiceView.vue?vue&type=style&index=0&id=30d0360e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30d0360e"]])

export default __exports__